import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useState, useRef } from 'react'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetHubs } from '../../store/hubs'
import { appCreateSponsor, appUpdateSponsor, uploadSponsorImage } from '../../store/sponsor'
import ImageUpload from '../../components/ImageUpload'
import { appGetAllUser } from '../../store/user'
import { appAllGetPaymentSettings } from '../../store/paymentsetting'
import { toast } from 'react-toastify'
import { toCamelCase } from '../../utils/Function'

function NewSponsor() {
	const { id } = useParams()

	const location = useLocation()
	const sponsorFromRoute = location.state?.sponsor

	//console.log('sponsorFromRoute', sponsorFromRoute)

	const isInitialEditLoad = useRef(true)

	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [isDurationEnabled, setIsDurationEnabled] = useState(true)
	const Hub = useSelector(state => state?.hubReducer?.hub)
	const Sanstha = useSelector(state => state?.sansthaReducer?.sanstha)
	const payment = useSelector(state => state.paymentSettingsReducer.payment)
	const [startDate, setStartDate] = useState(new Date())
	const [endDate, setEndDate] = useState(
		new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
	)
	const users = useSelector(state => state?.usersReducer.users)

	// console.log('users', users)

	useEffect(() => {
		dispatch(appAllGetHubs({ page: 1, limit: 1000 }))
		dispatch(appAllGetPaymentSettings())
	}, [])

	// console.log('payment', payment)

	const handleHubChange = option => {
		formik.setFieldValue('hub', option?.value)
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: option?.value }))
		dispatch(appGetAllUser({ page: 1, limit: 1000, hub: option?.value }))
	}
	const handleSansthaChange = option => {
		formik.setFieldValue('sanstha', option?.value)
		dispatch(appGetAllUser({ page: 1, limit: 1000, sansthaId: option?.value }))
	}

	useEffect(() => {
		if (!id || !sponsorFromRoute) return

		const s = sponsorFromRoute

		formik.setValues({
			name: s.name || '',
			image: s.image || '',
			hub: s.hub?._id || '',
			sanstha: s.sanstha?._id || '',
			// description: s.description || '',
			user: s.user?._id || '',
			startDate: s.startDate ? new Date(s.startDate).toISOString().split('T')[0] : '',
			endDate: s.endDate ? new Date(s.endDate).toISOString().split('T')[0] : '',
			sponsorDate: s.sponsorDate || '',
			sponsorfee: s.sponsorfee ?? 0,
			note: s.note || '',
		})

		if (s.hub?._id) {
			dispatch(appGetAllUser({ page: 1, limit: 1000, hub: s.hub._id }))
			dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: s.hub._id }))
		}
	}, [id, sponsorFromRoute])

	const today = new Date().toISOString().split('T')[0]

	const nextYearDate = new Date()
	nextYearDate.setFullYear(nextYearDate.getFullYear() + 1)
	const nextYear = nextYearDate.toISOString().split('T')[0]

	const allCommunityFee = payment?.allcommunity || 0
	const communityFee = payment?.community?.price || 0
	const sansthaFee = payment?.sanstha?.price || 0

	const formik = useFormik({
		initialValues: {
			name: '',
			image: '',
			hub: '',
			// description: '',
			sanstha: '',
			user: '',
			startDate: today || '',
			endDate: nextYear || '',
			sponsorDate: '',
			sponsorfee: 0,
			note: '',
		},
		validationSchema: Yup.object({
			image: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),
			user: Yup.string().when([], {
				is: () => isDurationEnabled,
				then: schema => schema.required('User is required'),
				otherwise: schema => schema.notRequired(),
			}),
			startDate: Yup.string().required('Start Date is Required'),
			endDate: Yup.string().required('End Date is Required'),
		}),
		onSubmit: values => {
			let sponsorName = values.name
			if (values.user) {
				const selectedUser = Array.isArray(users) ? users.find(u => u._id === values.user) : null
				if (selectedUser) {
					sponsorName = selectedUser.firstName
				}
			}

			const temp_obj = {
				name: sponsorName,
				image: values?.image,
				hub: values?.hub,
				// description: values?.description,
				sanstha: values?.sanstha,
				user: values?.user,
				startDate: values?.startDate,
				endDate: values?.endDate,
				sponsorDate: values?.sponsorDate,
				sponsorfee: values?.sponsorfee,
				amount: Number(values?.sponsorfee || 0),
				note: values?.note,
				navigate: navigate,
			}

			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)

			console.log('filtered_obj', filtered_obj)
			filtered_obj.navigate = navigate

			if (id) {
				dispatch(appUpdateSponsor({ ...filtered_obj, id })).then(() => {
					toast.success('Sponsor Update Successfully')
					navigate('/sponsor')
				})
			} else {
				dispatch(appCreateSponsor(filtered_obj)).then(() => {
					formik.resetForm()
					navigate('/sponsor')
				})
			}
		},
	})

	useEffect(() => {
		if (!payment) return

		const hasHub = Boolean(formik.values.hub)
		const hasSanstha = Boolean(formik.values.sanstha)

		let fee = allCommunityFee

		if (hasHub && !hasSanstha) fee = communityFee
		if (hasHub && hasSanstha) fee = sansthaFee

		if (!id) {
			formik.setFieldValue('sponsorfee', fee)
			return
		}

		if (id) {
			// Skip first render (keep backend value)
			if (isInitialEditLoad.current) {
				isInitialEditLoad.current = false
				return
			}

			// After user changes hub/sanstha → recalc
			formik.setFieldValue('sponsorfee', fee)
		}
	}, [formik.values.hub, formik.values.sanstha, payment])

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading">
					<div>
						<span>Sponsor</span> <span>/ {id ? 'Edit Sponsor' : 'New Sponsor'}</span>
					</div>
				</div>
				<div className="form-group d-flex align-items-center">
					<label className="mr-3 mb-0" htmlFor="durationSwitch">
						Sponsor Belongs to Platform
					</label>
					<div className="custom-control custom-switch">
						<input
							type="checkbox"
							className="custom-control-input"
							id="durationSwitch"
							checked={isDurationEnabled}
							onChange={() => setIsDurationEnabled(prev => !prev)}
						/>
						<label className="custom-control-label" htmlFor="durationSwitch"></label>
					</div>
				</div>

				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsored on Community level </label>
										<Select
											name="_id"
											options={
												Array.isArray(Hub?.data)
													? Hub?.data.map(place => ({
															value: place?._id,
															label: toCamelCase(place?.name),
													  }))
													: []
											}
											onChange={handleHubChange}
											className="basic-multi-select"
											classNamePrefix="select Community..."
											value={
												Array.isArray(Hub?.data)
													? Hub?.data
															.filter(option => option._id === formik?.values?.hub)
															.map(option => ({
																value: option?._id,
																label: toCamelCase(option?.name),
															}))[0]
													: null
											}
											placeholder="Select.."
										/>
										{formik.touched.hub && formik.errors.hub ? (
											<div style={{ color: 'red' }}>{formik.errors.hub}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<ImageUpload
										uploadFunction={uploadSponsorImage}
										fieldName="image"
										value={formik.values.image}
										onChange={value => formik.setFieldValue('image', value.url)}
										error={formik.touched.image && formik.errors.image ? formik.errors.image : null}
									/>
								</div>
							</div>
							<div className="row" style={{ padding: '0 0 15px 0' }}>
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsored on Sanstha level</label>
										<Select
											options={
												Array.isArray(Sanstha)
													? Sanstha.map(place => ({
															value: place?._id,
															label: toCamelCase(place?.name),
													  }))
													: []
											}
											onChange={handleSansthaChange}
											value={
												Array.isArray(Sanstha)
													? Sanstha.filter(option => option._id === formik?.values?.sanstha).map(
															option => ({
																value: option._id,
																label: option.name,
															}),
													  )[0]
													: null
											}
											placeholder="Select Sanstha.."
										/>
									</div>
								</div>
								{isDurationEnabled ? (
									<div className="col-md-6">
										<div className="form-group">
											<label>Select Users</label>
											<Select
												options={
													Array.isArray(users)
														? users.map(user => ({
																value: user._id,
																label: `${user.firstName || ''} ${user.lastName ||
																	''} (${user.mobile || ''})`,
														  }))
														: []
												}
												onChange={option => {
													formik.setFieldValue('user', option?.value)

													const selectedUser = users.find(u => u._id === option?.value)
													if (selectedUser) {
														formik.setFieldValue(
															'name',
															`${selectedUser.firstName || ''} ${selectedUser.lastName || ''}`,
														)
													}
												}}
												onBlur={() => formik.setFieldTouched('user', true)}
												value={
													users
														?.filter(user => user._id === formik.values.user)
														.map(user => ({
															value: user._id,
															label: `${user.firstName || ''} ${user.lastName ||
																''} (${user.mobile || ''})`,
														}))[0] || null
												}
												placeholder="Select User..."
											/>

											{formik.touched.user && formik.errors.user && (
												<div style={{ color: 'red' }}>{formik.errors.user}</div>
											)}
										</div>
									</div>
								) : (
									<div className="col-md-6">
										<div className="form-group">
											<label>Name </label>
											<input
												className="form-control"
												name="name"
												type="text"
												onChange={formik.handleChange}
												value={formik.values.name}
											/>
										</div>
									</div>
								)}
								{/* <div className="col-md-6">
									<div className="form-group">
										<label>Description </label>
										<textarea
											className="form-control"
											name="description"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.description}
											rows="3"
										/>
										{formik.touched.description && formik.errors.description ? (
											<div style={{ color: 'red' }}>{formik.errors.description}</div>
										) : null}
									</div>
								</div> */}
							</div>

							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Date of offline payment received </label>

										<input
											type="date"
											className="form-control"
											value={formik.values.sponsorDate || ''}
											onChange={e => {
												const rawValue = e.target.value
												if (!rawValue) {
													formik.setFieldValue('sponsorDate', '')
													return
												}

												const dateObj = new Date(rawValue)
												if (isNaN(dateObj.getTime())) return

												formik.setFieldValue('sponsorDate', rawValue)
											}}
										/>
										{formik.touched.sponsorDate && formik.errors.sponsorDate ? (
											<div style={{ color: 'red' }}>{formik.errors.sponsorDate}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>Sponsor Fee </label>
										<input
											type="number"
											className="form-control"
											name="sponsorfee"
											value={formik.values.sponsorfee ?? 0}
											readOnly
										/>
									</div>
								</div>

								<div className="col-md-6">
									<div className="form-group">
										<label>Notes (payment details and received by)</label>
										<textarea
											className="form-control"
											name="note"
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											value={formik.values.note}
											rows="3"
										/>
									</div>
								</div>
							</div>

							<div className="row" style={{ padding: '0 0 15px 0' }}>
								<div className="col-md-6">
									<div className="form-group">
										<label>Start Date </label>
										<input
											type="date"
											className="form-control"
											value={formik.values.startDate || ''}
											onChange={e => {
												if (!e.target.value) {
													formik.setFieldValue('startDate', '')
													formik.setFieldValue('endDate', '')
													setStartDate(null)
													setEndDate(null)
													return
												}
												const dateValue = new Date(e.target.value)
												if (isNaN(dateValue.getTime())) {
													return
												}
												setStartDate(dateValue)
												let dateOnly = dateValue.toISOString().split('T')[0]
												formik.setFieldValue('startDate', dateOnly)

												const nextYear = new Date(dateValue)
												nextYear.setFullYear(nextYear.getFullYear() + 1)
												setEndDate(nextYear)
												formik.setFieldValue('endDate', nextYear.toISOString().split('T')[0])
											}}
										/>
										{formik.touched.startDate && formik.errors.startDate ? (
											<div style={{ color: 'red' }}>{formik.errors.startDate}</div>
										) : null}
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>End Date </label>
										<input
											type="date"
											className="form-control"
											value={formik.values.endDate || ''}
											readOnly
										/>
										{formik.touched.endDate && formik.errors.endDate ? (
											<div style={{ color: 'red' }}>{formik.errors.endDate}</div>
										) : null}
									</div>
								</div>
							</div>
							<div>
								<button
									className="btn btn-labeled btn-success mb-2"
									type="submit"
									style={{ fontSize: '17px' }}
								>
									<span className="btn-label">
										<i className="fa fa-check"></i>
									</span>
									{id ? 'Update' : 'Create'}
								</button>
								<span style={{ padding: '0 10px' }}>or</span>
								<button
									className="btn btn-labeled btn-secondary mb-2"
									type="button"
									style={{ fontSize: '17px' }}
									onClick={() => navigate('/sponsor')}
								>
									<span className="btn-label">
										<i className="fa fa-times"></i>
									</span>
									Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewSponsor
